import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { SessionService } from '../session/shared/session/session-service/session.service';
import {
  PersonalLoanApplicationsForBorrowerResponse,
  CreatePersonalLoanApplicationResponse,
  CreatePersonalLoanApplicationRequest,
  PersonalLoanReapplyStatusResponse,
  PromoCodeValidationResponse,
  PromoCodeValidationRequest,
  TouchpointRequest,
  TouchpointResponse,
} from '../../models';
import {
  BorrowerPersonalLoanApplicationApi
} from '../../../../../generated/internalApi/api/BorrowerPersonalLoanApplicationApi';
import {
  PersonalLoanApplicationPromoCodeValidationApi
} from '../../../../../generated/internalApi/api/PersonalLoanApplicationPromoCodeValidationApi';
import { PersonalLoanApplicationTouchpointApi } from '../../../../../generated/internalApi/api/PersonalLoanApplicationTouchpointApi';
import { ApiService } from '../api.service';
import {
  LDCommonWebApiResponseApiResponseLDCLPBPPublicApiModelsValidationPromoCodeValidationResponse
} from '../../../../../generated/internalApi';

@Injectable()
export class BorrowerPersonalLoanApplicationService extends ApiService {

  private get borrowerGuid(): string {
    return this.sessionService.borrowerGuid;
  }

  constructor(
    private borrowerPLAApi: BorrowerPersonalLoanApplicationApi,
    private touchpointApi: PersonalLoanApplicationTouchpointApi,
    private promoCodeApi: PersonalLoanApplicationPromoCodeValidationApi,
    protected sessionService: SessionService) {
      super(sessionService);
    }


  public getPersonalLoanApplication(): Observable<PersonalLoanApplicationsForBorrowerResponse> {
    return this.borrowerPLAApi.borrowerPersonalLoanApplicationGetPersonalLoanApplicationsForBorrower(this.borrowerGuid, this.authToken)
      .map((response) => {
        this.sessionService.personalLoanSession.data.loanApplicationGuid = response.data.loanApplications[0].guid;

        return response.data;
      }).catch((err, caught) => {
        console.error(err);

        return throwError(err);
      });
  }

  public createPersonalLoanApplicationForBorrower(
    loanPurpose: CreatePersonalLoanApplicationRequest.LoanPurposeEnum,
    loanAmount: number,
    termsOfUseAccepted: boolean = false,
    eSignConsentAccepted: boolean = false,
    tcpaDisclosureAccepted: boolean = false,
    creditReportAuthorizationAccepted: boolean = false,
    jornayaLeadID: string = null
  ): Observable<CreatePersonalLoanApplicationResponse> {
    const request: CreatePersonalLoanApplicationRequest = {
      loanPurpose: loanPurpose,
      requestedLoanAmount: loanAmount,
      deviceInfo: {},
      consent: {
        termsOfUseAccepted: termsOfUseAccepted,
        eSignConsentAccepted: eSignConsentAccepted,
        creditReportAuthorizationAccepted: creditReportAuthorizationAccepted,
        tcpaDisclosureAccepted: tcpaDisclosureAccepted
      },
      jornayaLeadID
    };

    return this.borrowerPLAApi.borrowerPersonalLoanApplicationCreatePersonalLoanApplicationForBorrower(
        this.borrowerGuid,
        request,
        this.authToken
      )
      .map(response => response.data)
      .catch((err, caught) => {
        console.error(err);

        return throwError(err);
      });
  }

  public getPersonalLoanReapplyStatus(): Observable<PersonalLoanReapplyStatusResponse> {
    return this.borrowerPLAApi.borrowerPersonalLoanApplicationGetReapplyStatusResponse(this.borrowerGuid, this.authToken)
      .map((response) => {
        this.sessionService.personalLoanSession.data.reapplyStatus = response.data.status;

        return response.data;
      }).catch((err, caught) => {
        console.error(err);
        return throwError(err);
      });
  }

  public validatePromoCode(
    promoCode: string, email: string)
    : Observable<LDCommonWebApiResponseApiResponseLDCLPBPPublicApiModelsValidationPromoCodeValidationResponse> {
    const request: PromoCodeValidationRequest = {
      promoCode,
      email
    };

    return this.promoCodeApi.personalLoanApplicationPromoCodeValidationValidatePromoCode(request, this.authToken)
      .catch(err => {
        console.error(err);
        return throwError(err);
      });
  }

  public createTouchpoint(request: TouchpointRequest): Observable<TouchpointResponse> {
    return this.touchpointApi.personalLoanApplicationTouchpointCreateTouchpoint(request, this.authToken)
      .map(response => response.data)
      .catch(err => {
        console.error(err);
        return throwError(err);
      });
  }
}
